import React from 'react';
import { CardBody } from "reactstrap";
import './ActiveParikami.css'

const ActiveParikamiCardBody = () => {
    return (
        <CardBody className="card-body pt-0">
            <div className="right-side icon-right-info">
                <i className="fa fa-user"></i>
                <div className="shap-block">
                    <div className="rounded-shap animate-bg-primary">
                        <i className='circle3'></i>
                        <i className='circle4'></i>
                    </div>
                </div>
            </div>
        </CardBody>
    );
};

export default ActiveParikamiCardBody;
